import { render, staticRenderFns } from "./ExchangeHeader.vue?vue&type=template&id=0ba3d97c&scoped=true&"
import script from "./ExchangeHeader.vue?vue&type=script&lang=js&"
export * from "./ExchangeHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeHeader.vue?vue&type=style&index=0&id=0ba3d97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba3d97c",
  null
  
)

export default component.exports